import { render, staticRenderFns } from "./MerchantProfile.vue?vue&type=template&id=11e5ba88&scoped=true&"
import script from "./MerchantProfile.vue?vue&type=script&lang=js&"
export * from "./MerchantProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e5ba88",
  null
  
)

export default component.exports